export const TOP_SCORES_MAX_STUDENTS = 8
